import React from 'react';
import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import IconReusable from '../../../components/IconReusable';
import { useSelector } from 'react-redux';

const DisplaySelectedRole = ({ role, onDelete }) => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const showHistory = useSelector(state => state.entityReducer.show_history);
    console.log(role, 'role in DisplaySelectedRole');
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: { xs: 1, md: 2 },
        }}>
            <Box
                sx={{
                    width: { xs: 32, md: 64 },
                    height: { xs: 32, md: 64 },
                    // borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // border: '1px solid #D9D9D9',
                }}
            >
                <Box
                    component="img"
                    src={role?.manufacturer_logo}
                    alt={role?.manufacturer_name}
                    sx={{ width: '100%', height: '100%', objectFit: 'contain', border: '1px solid #D9D9D9', borderRadius: 1 }}
                    onError={(e) => {
                        e.target.style.display = 'none';
                    }}
                />
            </Box>
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'flex-start', gap: { xs: 1, md: 2 } }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 0.5, md: 1 } }}>
                    <Box>
                        <Typography variant="bodyL">
                            {role?.manufacturer_name}
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#666666' }}>
                            {role?.role_name}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            {onDelete && (
                <IconButton
                    onClick={() => onDelete(role)}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        cursor: 'pointer',
                        width: '24px',
                        height: '24px',
                        justifyContent: 'center',
                        color: !showHistory ? '#995A00' : '#E5E5E5',
                    }}
                    disabled={showHistory}
                        
                >
                    <IconReusable name='Delete'  color={!showHistory ? '#333' : '#E5E5E5' } size={isMobile ? 16 : 24} />
                </IconButton>
            )}
        </Box>
    );
};

export default DisplaySelectedRole;
